import ImportRepository from "@domain/repositories/ImportRepository";
import UseCase from "@domain/UseCase";
import { ImportHistory } from "@domain/models/ImportHistory";

type Input = void;

type Output = Promise<ImportHistory[]>;

export class GetImportHistoryUseCase implements UseCase<Input, Output> {
  constructor(private readonly importRepository: ImportRepository) {}

  execute() {
    return this.importRepository.getImportHistory();
  }
}
